<template>
  <div class="login">
    <div class="login-more ">
      <div class="justify-center align-center d-flex width-height">
        <div>
          <v-row
            class=" justify-center align-center d-flex pa-0"
            style="width:100%; height:80px;"
          >
            <img src="/static/main/중흥-logo.png" style="height:80px;" />
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-card
              width="407"
              height="432"
              class="pa-40  card"
              style="border-radius:0px 0px 15px 0px;"
            >
              <v-row class="align-center justify-center pa-0 pb-8 pt-0">
                <img
                  src="/static/login/상단 텍스트_아이콘.png"
                  v-if="windowWidth > 500"
                />
              </v-row>
              <h2 v-if="windowWidth <= 500" class="font-40">LOGIN</h2>
              <v-row class="pl-3">
                <input
                  placeholder="아이디를 입력해주세요."
                  class="input"
                  v-model="id"
                  @keyup.enter="$refs.password.focus()"
                />
              </v-row>
              <v-row class="pt-4 pl-3">
                <input
                  placeholder="비밀번호를 입력해주세요."
                  class="input"
                  v-model="password"
                  type="password"
                  @keyup.enter="login"
                  ref="password"
                />
              </v-row>
              <v-row
                width="79"
                height="19"
                class=" align-center d-flex pt-2 pb-5 pl-3"
              >
                <input type="checkbox" v-model="autoLogin" />
                <span
                  @click="autoLogin = !autoLogin"
                  class=" pl-2 "
                  style="color:#8497B0"
                >
                  자동로그인</span
                >
              </v-row>
              <v-row class="pt-3 pb-3 justify-center">
                <v-btn
                  class="login-Btn"
                  @click="login()"
                  :width="windowWidth > 500 ? 300 : 299"
                  height="44"
                  >login</v-btn
                >
              </v-row>
              <v-row class=" justify-center d-flex pa-0 ">
                <v-btn
                  @click="
                    $router.push({ name: 'IdFind', params: { idCheck: true } })
                  "
                  class="btn"
                  >아이디 찾기</v-btn
                >
                <h2>/</h2>
                <v-btn
                  @click="
                    $router.push({
                      name: 'PassFind',
                      params: { idCheck: false },
                    })
                  "
                  class="btn"
                  >비밀번호 찾기</v-btn
                >
              </v-row>
            </v-card>
          </v-row>
          <v-row class="ma-0 pa-0 align-center justify-center mt-5 pt-5">
            <img src="/static/login/companylogo.png" />
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserApi from "@/api/UserService";
import AppSettingAPI from "@/api/AppSettingService";
import Mobile from "@/mixin/Mobile";

export default {
  mixins: [Mobile],
  data: () => ({
    id: "",
    password: "",
    autoLogin: true,
    tempImage: "",
  }),

  computed: {
    userId() {
      return this.$store.getters.getUserList.userId;
    },
  },

  methods: {
    async login() {
      let data = {
        accountName: this.id,
        accountPassword: this.password,
        autoLogin: this.autoLogin,
      };
      let returnData = await UserApi.userLogin(data);
      if (returnData.data.success == "fail") {
        this.password = "";
        this.$bus.$emit(
          "dialog",
          "로그인에 실패하셨습니다. 다시 시도해주세요."
        );
      } else {
        let data = await UserApi.userInformaion({
          userId: returnData.data.user.userId,
        });
        this.$store.commit("userListChange", data.data.userInformation);
        let status;
        if (this.qrText) {
          status = {
            name: "qrCode",
            query: {
              qrText: this.qrText,
            },
          };
        } else {
          status = {
            name: "ChoiceCon",
            params: {
              loginId: this.userId,
            },
          };
        }
        await this.getAppSetting();
        this.$router.push(status);
      }
    },
    async getAppSetting() {
      try {
        let { data } = await AppSettingAPI.appSetting();
        this.$store.commit("projectName", data.addedSettingInfos.projectName);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
.font-40 {
  font-size: 40px;
}

.card {
  z-index: 1;
  border: none !important;
  background-color: transparent;
  box-shadow: none !important;
}

.pa-40 {
  padding: 40px;
}

.btn {
  color: #666666 !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

h2 {
  color: white;
}

.width-height {
  width: 100%;
  height: 100%;
}

.row {
  margin: 0px !important;
}

.input {
  width: 300px;
  height: 40px;
  border-radius: 0px;
  border: 1px solid #8497b0;
  padding-left: 12px;
  background: white;
}

.login-Btn {
  background: #8497b0 !important;
  color: white !important;
  font-style: Bold;
  font-size: 18px !important;
  border-radius: 100px !important;
  left: 0px;
  top: 0px;
  box-shadow: 0px 2px 5px 0px #00000033;
}

.login {
  background-image: url(../../assets/login/test.png);
  top: 0;
  left: 0;
  position: absolute;
  background-size: cover;
  box-shadow: 0px 7px 14px 0px #36568ef2;
  content: "";
  height: 100vh;
  width: 100vw;

  z-index: -5;
}

.login-more {
  top: 0;
  left: 0;
  position: absolute;
  background-size: 100%;
  opacity: 0.8;
  z-index: -1;
  width: 100%;
  height: 100%;
}

.login {
  height: 100%;
  position: relative;
  z-index: 1;
}

.input::placeholder {
  color: #cccccc;
}
</style>
